document.addEventListener('DOMContentLoaded', () => {
  const guideOpen = new URLSearchParams(window.location.search).get('size-guide')
  if (guideOpen) {
    document.querySelector(`tool-tip-trigger[data-tool-tip='cust-size-chart']`).click()
    const sizeGuide = document.querySelector('.tool-tip__content .cus-size-chart .size_guide')
    const ringSizer = document.querySelector('.tool-tip__content .cus-size-chart .ring_sizer')
    sizeGuide.style.display = 'none'
    ringSizer.style.display = 'block'
    document.querySelector('.tool-tip__content .cus-size-chart .cus-size-chart-header').innerText = 'Digital Ring Sizer'
  }
})

document.addEventListener('tooltip:open', (e) => {
  if (e.detail.context !== 'cust-size-chart') return

  // 动态生成当前页面二维码
  genQrcode()

  // Size Guide Tabs Click
  const guildTabs = document.querySelector('.tool-tip__content .cus-size-chart .size_guide .size_guide-tabs')
  guildTabs.addEventListener('click', (e) => {
    let target = e.target
    if (target.tagName !== 'DIV') {
      target = target.parentNode
    }
    const targetClass = target.className
    if (targetClass.indexOf('active') === -1) {
      target.classList.add('active')
      ;(target.nextElementSibling || target.previousElementSibling).classList.remove('active')

      const guideContent1 = document.querySelector('.tool-tip__content .cus-size-chart .size_guide-content-1')
      const guideContent2 = document.querySelector('.tool-tip__content .cus-size-chart .size_guide-content-2')
      if (targetClass.indexOf('size_guide-tab-1') === -1) {
        guideContent1.style.display = 'none'
        guideContent2.style.display = 'block'
      } else {
        guideContent1.style.display = 'block'
        guideContent2.style.display = 'none'
      }
    }
  })

  // Size Guide guildBtn Click
  const guildBtn = document.querySelector(
    '.tool-tip__content .cus-size-chart .size_guide-contents .size_guide-content-button'
  )
  guildBtn.addEventListener('click', () => {
    const sizeGuide = document.querySelector('.tool-tip__content .cus-size-chart .size_guide')
    const ringSizer = document.querySelector('.tool-tip__content .cus-size-chart .ring_sizer')
    sizeGuide.style.display = 'none'
    ringSizer.style.display = 'block'
    document.querySelector('.tool-tip__content .cus-size-chart .cus-size-chart-header').innerText = 'Digital Ring Sizer'
  })

  // Ring Sizer Slider input
  let cardBoxHeight = 300
  let ringWidth = 100
  let minRingWidth = 78.3
  let maxRingWidth = 105.56

  function computeDiameter() {
    return ringWidth * (53.98 / cardBoxHeight)
  }

  function getSizers() {
    const diameter = computeDiameter()
    let arteSize = 0
    let US = 0
    let UK = 0
    let EU = 0
    if (diameter < 14.5) {
      arteSize = 30
      US = 3
      UK = 'F'
      EU = 44
    } else if (diameter >= 14.5 && diameter < 15.3) {
      arteSize = 40
      US = 4
      UK = 'H'
      EU = 47
    } else if (diameter >= 15.3 && diameter < 16.1) {
      arteSize = 50
      US = 5
      UK = 'J 1/2'
      EU = 49
    } else if (diameter >= 16.1 && diameter < 16.9) {
      arteSize = 60
      US = 6
      UK = 'L 1/2'
      EU = 52
    } else if (diameter >= 16.9 && diameter < 17.7) {
      arteSize = 70
      US = 7
      UK = 'N 1/2'
      EU = 54
    } else if (diameter >= 17.7 && diameter < 18.55) {
      arteSize = 80
      US = 8
      UK = 'P 1/2'
      EU = 57
    } else if (diameter >= 18.55) {
      arteSize = 90
      US = 9
      UK = 'R 1/2'
      EU = 59
    }
    return [arteSize, UK, US, EU]
  }

  function setSizers() {
    const sizers = getSizers()
    sizerVals.forEach((size, index) => (size.innerText = sizers[index]))
  }

  function computeRingRange() {
    minRingWidth = 14.1 / (53.98 / cardBoxHeight)
    maxRingWidth = 19 / (53.98 / cardBoxHeight)
  }

  const sliders = document.querySelectorAll('.tool-tip__content .cus-size-chart .ring_sizer-step-slider input')
  const slider1_decrease = document.querySelector(
    '.tool-tip__content .cus-size-chart .ring_sizer-step-slider.slider_1 .decrease'
  )
  const slider1_increase = document.querySelector(
    '.tool-tip__content .cus-size-chart .ring_sizer-step-slider.slider_1 .increase'
  )
  const slider2_decrease = document.querySelector(
    '.tool-tip__content .cus-size-chart .ring_sizer-step-slider.slider_2 .decrease'
  )
  const slider2_increase = document.querySelector(
    '.tool-tip__content .cus-size-chart .ring_sizer-step-slider.slider_2 .increase'
  )
  const cardBox = document.querySelector('.tool-tip__content .ring_sizer-step-card')
  const ring = document.querySelector('.tool-tip__content .ring_sizer-step-ring>div')
  const sizerVals = document.querySelectorAll('.tool-tip__content .ring_sizer-step-sizes > div span:last-child')

  function setCardHeight() {
    cardBoxHeight = 200 + (200 * sliders[0].value) / 100
    cardBox.style.height = cardBoxHeight + 'px'
    computeRingRange()
  }
  function setRingWidth() {
    ringWidth = minRingWidth + ((maxRingWidth - minRingWidth) * sliders[1].value) / 100
    ring.style.height = ring.style.width = ringWidth + 'px'
  }

  function nextRangerVal(curSize, flag) {
    let Val = 0
    if (flag === 1) {
      if (curSize === 30) Val = 0.8 / 4.9 * 100
      if (curSize === 40) Val = 1.6 / 4.9 * 100
      if (curSize === 50) Val = 2.4 / 4.9 * 100
      if (curSize === 60) Val = 3.2 / 4.9 * 100
      if (curSize === 70) Val = 4 / 4.9 * 100
      if (curSize === 80) Val = 100
      if (curSize === 90) Val = 100
    } else {
      if (curSize === 30) Val = 0
      if (curSize === 40) Val = 0
      if (curSize === 50) Val = 0.8 / 4.9 * 100
      if (curSize === 60) Val = 1.6 / 4.9 * 100
      if (curSize === 70) Val = 2.4 / 4.9 * 100
      if (curSize === 80) Val = 3.2 / 4.9 * 100
      if (curSize === 90) Val = 4 / 4.9 * 100
    }
    return Val
  }
  sliders[0].addEventListener('input', () => {
    setCardHeight()
    setSizers()
    sliders[1].value = (computeDiameter() - 14.1) / 4.9 * 100
  })
  sliders[1].addEventListener('input', () => {
    setRingWidth()
    setSizers()
  })

  slider1_decrease.addEventListener('click', () => {
    if (sliders[0].value <= 0) return
    sliders[0].value -= 1
    setCardHeight()
    setSizers()
  })
  slider2_decrease.addEventListener('click', () => {
    if (sliders[1].value <= 0) return
    sliders[1].value = nextRangerVal(getSizers()[0], -1)
    setRingWidth()
    setSizers()
  })
  slider1_increase.addEventListener('click', () => {
    if (sliders[0].value >= 100) return
    sliders[0].value = Number(sliders[0].value) + 1
    setCardHeight()
    setSizers()
  })
  slider2_increase.addEventListener('click', () => {
    if (sliders[1].value >= 100) return
    sliders[1].value = nextRangerVal(getSizers()[0], 1)
    setRingWidth()
    setSizers()
  })

  // 动态生成当前页面二维码
  function genQrcode() {
    // const url = window.location.href + '&size-guide=1'
    let url = new URL(window.location.href)

    url.searchParams.append('size-guide', '1')

    console.log(url.toString())
    new QRCode(
      document.querySelector(
        '.tool-tip__content .cus-size-chart .size_guide-content-1-desktop .size_guide-content-qrcode'
      ),
      url.toString()
    )
  }
})
